import api, {type ApiResponse, doError} from "@/axios.js";
import {usePersonsStore} from './persons';
import {defineStore} from 'pinia'
import type {AxiosError} from "axios";
import type {PersonsInterface} from "@/stores/persons.ts";
import type {WorkingTimeInterface} from "@/stores/workingTime.ts";

export interface ServiceOptionsInterface {
    id: number;
    name: string;
    service_id: number
    price: number;
    duration: number
    translations?:{
        name:{
            [key:string]:string
        },
        short_description:{
            [key:string]:string
        },
        description:{
            [key:string]:string
        }
    },
    persons_ids: number[]
}
export interface ServicesInterface {
    id: number;
    name: string;
    max_count?: number;
    short_description: string;
    description: string;
    photos:{
        icon:string
        thumb:string
        photo:string
    };
    options: ServiceOptionsInterface[],
    translations?:{
        name:{
            [key:string]:string
        },
        short_description:{
            [key:string]:string
        },
        description:{
            [key:string]:string
        }
    }
    working_times?:WorkingTimeInterface[]
    persons?: PersonsInterface[]
    first_available_reservation?:WorkingTimeInterface
}

export const useServicesStore = defineStore('services', {
    state: () => ({
        _list: null as ServicesInterface[] | null,
        _full_list: null as ServicesInterface[] | null,
    }),
    getters: {
        list: (state) => state._list,
        full_list: (state) => state._full_list,

    },
        actions: {
            async load(): Promise<void> {
                try {
                    const response = await api.get<ApiResponse<ServicesInterface[]>>('/services');
                    this._list = response.data.data;

                }
                catch (err: AxiosError | any) {
                    doError(err);
                }
            },
            async loadFull(): Promise<void> {
                try {
                    const response = await api.get<ApiResponse<ServicesInterface[]>>('/services/full');
                    this._full_list = response.data.data;

                }
                catch (err: AxiosError | any) {
                    doError(err);
                }
            },
            async destroy(id: number): Promise<void> {
                try {
                    await api.delete(`/services/${id}`);
                    this._full_list=null;
                    this._list = this._list!.filter(item => item.id !== id);
                }
                catch (err: AxiosError | any) {
                    doError(err);
                }
            },
            async destroyOption(service_id: number,id: number): Promise<void> {
                try {
                    await api.delete(`/service-options/${id}`);
                    usePersonsStore()._list=null;
                    this._full_list=null;
                    const index = this._list!.findIndex(item => item.id === service_id);

                    if (index !== -1) {
                        this._list![index].options = this._list![index].options.filter(item => item.id !== id);
                    }

                }
                catch (err: AxiosError | any) {
                    doError(err);
                }
            },
            async update(service: ServicesInterface) {

                try {
                    const response=await api.put(`/services/${service.id || 0}`, service);
                    this._full_list=null;
                    const index = this._list!.findIndex(item => item.id === service.id);
                    if (index !== -1) {
                        this._list![index] = response.data.data;
                    } else {
                        this._list!.push(response.data.data);
                    }
                    return response.data.data.id;
                }
                catch (err: AxiosError | any) {
                    doError(err);
                }
            },
            async updateServiceOption(service_option: ServiceOptionsInterface): Promise<void> {
                try {
                    const response=await api.put(`/service-options/${service_option.id || 0}`, service_option);
                    usePersonsStore()._list=null;
                    this._full_list=null;
                    const index = this._list!.findIndex(item => item.id === Number(service_option.service_id));
                        const serviceIndex = this._list![index].options.findIndex(item => item.id === service_option.id);
                        if (serviceIndex !== -1) {
                            this._list![index].options[serviceIndex] = response.data.data;
                        } else {
                            this._list![index].options.push(response.data.data);
                        }

                }
                catch (err: AxiosError | any) {
                    doError(err);
                }
            }
        }
})